export var AlertMessageBoxType;
(function (AlertMessageBoxType) {
    AlertMessageBoxType[AlertMessageBoxType["High"] = 0] = "High";
    AlertMessageBoxType[AlertMessageBoxType["Medium"] = 1] = "Medium";
    AlertMessageBoxType[AlertMessageBoxType["Low"] = 2] = "Low";
})(AlertMessageBoxType || (AlertMessageBoxType = {}));
